const e = {
  undo: "Annulla",
  redo: "Ripeti",
  confirm: "Conferma",
  clear: "Rimuovi",
  more: "più",
  cancel: "Annulla",
  update: "Aggiorna"
}, a = {
  positiveText: "Conferma",
  negativeText: "Annulla"
}, i = {
  placeholder: "Seleziona",
  loading: "Caricamento"
}, o = {
  clear: "Rimuovi",
  now: "Ora",
  confirm: "Conferma",
  selectTime: "Seleziona l'ora",
  selectDate: "Seleziona data",
  datePlaceholder: "Seleziona data",
  datetimePlaceholder: "Seleziona data e ora",
  monthPlaceholder: "Seleziona Mese",
  yearPlaceholder: "Seleziona anno",
  quarterPlaceholder: "Seleziona Trimestre",
  startDatePlaceholder: "Data di inizio",
  endDatePlaceholder: "Data di fine",
  startDatetimePlaceholder: "Data e ora di inizio",
  endDatetimePlaceholder: "Data e ora di fine",
  startMonthPlaceholder: "Mese di inizio",
  endMonthPlaceholder: "Mese di fine",
  today: "Oggi"
}, n = {
  checkTableAll: "Seleziona tutto nella tabella",
  uncheckTableAll: "Deseleziona tutto nella tabella",
  confirm: "Conferma",
  clear: "Rimuovi",
  apply: "Applica",
  filters: "Filtra",
  sort: "Ordina"
}, t = {
  sourceTitle: "Fonte",
  targetTitle: "Destinazione"
}, r = {
  selectAll: "Seleziona tutto",
  unselectAll: "Deseleziona tutto",
  clearAll: "Rimuovi"
}, l = {
  description: "Nessun dato"
}, c = {
  placeholder: "Seleziona"
}, s = {
  placeholder: "Seleziona l'ora",
  positiveText: "Ok",
  negativeText: "Annulla",
  now: "Ora"
}, d = {
  goto: "Goto",
  selectionSuffix: "pagina",
  next: "Successivo",
  previous: "Precedente"
}, p = {
  add: "Aggiungi"
}, m = {
  loading: "Caricamento"
}, g = {
  placeholder: "Inserisci"
}, u = {
  placeholder: "Inserisci"
}, f = {
  create: "Crea"
}, h = {
  title: "Editor del tema",
  clearAllVars: "Rimuovi tutte le variabili",
  clearSearch: "Cancella ricerca",
  filterCompName: "Filtra il nome del componente",
  filterVarName: "Filtra il nome della variabile",
  import: "Importa",
  export: "Esporta",
  restore: "Ripristina le impostazioni predefinite"
}, P = {
  tipPrevious: "Immagine precedente (←)",
  tipNext: "Immagine successiva (→)",
  tipCounterclockwise: "In senso antiorario",
  tipClockwise: "In senso orario",
  tipZoomOut: "Rimpicciolisci",
  tipZoomIn: "Ingrandisci",
  tipClose: "Chiudi (Esc)",
  tipOriginalSize: "Zoom alla dimensione originale"
}, C = {
  heading: "Ordina e filtra",
  sortHeading: "Ordina per",
  newestFirst: "Prima i più recenti",
  oldestFirst: "Prima i più vecchi",
  ascending: "Asc",
  descending: "Dai più recenti ai più vecchi",
  apply: "Applica",
  clear: "Rimuovi",
  cancel: "Annulla",
  filters: "Filtra"
}, v = {
  noMatchingFound: "Nessun risultato corrispondente trovato"
}, S = {
  margin: "Margine",
  padding: "Spaziatura interna",
  reset: "Ripristina",
  errorMsg: "Il valore fornito non è valido."
}, z = {
  brandColors: "Colori del brand",
  noBrandColors: "Non hai ancora aggiunto nessun colore del brand.",
  getStarted: "Inizia",
  add: "Aggiungi",
  default: "Predefinito"
}, D = {
  addColor: "Aggiungi nuovo colore",
  editColor: "Modifica Colore",
  add: "Aggiungi",
  noData: "Non hai ancora aggiunto alcun colore.",
  invalidCode: "Codice colore non valido",
  defaultColor: "Colori predefiniti"
}, T = {
  global: e,
  Popconfirm: a,
  Cascader: i,
  DatePicker: o,
  DataTable: n,
  LegacyTransfer: t,
  Transfer: r,
  Empty: l,
  Select: c,
  TimePicker: s,
  Pagination: d,
  DynamicTags: p,
  Log: m,
  Input: g,
  InputNumber: u,
  DynamicInput: f,
  ThemeEditor: h,
  Image: P,
  SortFilter: C,
  IconPicker: v,
  Spacing: S,
  BrandColorPicker: z,
  BrandBoard: D
};
export {
  D as BrandBoard,
  z as BrandColorPicker,
  i as Cascader,
  n as DataTable,
  o as DatePicker,
  f as DynamicInput,
  p as DynamicTags,
  l as Empty,
  v as IconPicker,
  P as Image,
  g as Input,
  u as InputNumber,
  t as LegacyTransfer,
  m as Log,
  d as Pagination,
  a as Popconfirm,
  c as Select,
  C as SortFilter,
  S as Spacing,
  h as ThemeEditor,
  s as TimePicker,
  r as Transfer,
  T as default,
  e as global
};
